import VerifySelection from './verify_selection';

export default VerifySelection;
